export const PROJECT_BASED = "Project";
export const SERVICE_BASED = "Service";

export const BUSINESS_MODEL_OPTIONS = [
  { value: PROJECT_BASED, label: "Project Based" },
  { value: SERVICE_BASED, label: "Service Based" },
];

export const isRealEstateBusiness = (domainName) => /real\s*estate|realty|property/i.test(String(domainName || ""));

const LOCATION_MAX = 60;

export const projectOptionLabel = (name, location) => {
  const loc = String(location || "").trim();
  if (!loc) return name;
  return `${name} — ${loc.length > LOCATION_MAX ? `${loc.slice(0, LOCATION_MAX - 1)}…` : loc}`;
};

/**
 * Which lead fields apply for a business type + model.
 * Project based: the lead only picks a project (no lead requirements or links).
 * Service based real estate (rentals, PG, brokerage): property requirements.
 * Other service businesses (stores, food, studios…): service + budget + preferred date.
 */
export function leadFieldProfile(domainName, model) {
  const realEstate = isRealEstateBusiness(domainName);
  const project = model === PROJECT_BASED;
  const service = model === SERVICE_BASED;
  // No model yet (tenant not updated): keep every field so nothing is lost.
  const unknown = !project && !service;
  const propertyDetails = unknown || (realEstate && service);
  return {
    model: unknown ? "" : model,
    project,
    service,
    realEstate,
    showDetails: !project,
    showLink: !project,
    showRequirementType: propertyDetails,
    showPropertyDetails: propertyDetails,
    showBudget: !project,
    showPreferredLocation: !project,
    showPreferredDate: service && !realEstate,
    showSiteVisit: project || propertyDetails,
    offeringLabel: project ? "Project" : service ? "Service" : "Project / Service",
    ownerLabel: project ? "Project Owner" : service ? "Brand / Branch" : "Client",
    linkLabel: service ? "Service Link" : "Property / Service Link",
    detailsTitle: unknown ? "Requirements" : propertyDetails ? "Property Requirements" : "Service Requirements",
  };
}
